/* ============================================================
   NEE — global.js
   Vanilla JS, no dependencies. Handles:
   1. Product image gallery (thumbnail -> main swap)
   2. Variant selection (updates price, availability, hidden id, image)
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Product image gallery ---------- */
  function initGalleries() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-full');
          if (main && full) { main.src = full; }
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  /* ---------- Variant selection ---------- */
  function initProductForms() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      var dataEl = form.querySelector('[data-product-variants]');
      if (!dataEl) { return; }

      var variants;
      try { variants = JSON.parse(dataEl.textContent); }
      catch (e) { return; }

      var selects = Array.prototype.slice.call(form.querySelectorAll('[data-option-index]'));
      var idInput = form.querySelector('[data-variant-id]');
      var priceEl = form.querySelector('[data-price]');
      var compareEl = form.querySelector('[data-compare]');
      var addBtn = form.querySelector('[data-add]');
      var addText = form.querySelector('[data-add-text]');
      var section = form.closest('.product') || document;
      var mainImg = section.querySelector('[data-gallery-main]');

      function currentSelection() {
        return selects.map(function (s) { return s.value; });
      }

      function findVariant(selection) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var opts = v.options || [];
          if (selection.length === 0) { return v; } // default-variant product
          if (opts.length !== selection.length) { continue; }
          var match = true;
          for (var j = 0; j < selection.length; j++) {
            if (String(opts[j]) !== String(selection[j])) { match = false; break; }
          }
          if (match) { return v; }
        }
        return null;
      }

      function update() {
        var variant = findVariant(currentSelection());

        if (!variant) {
          if (addBtn) { addBtn.disabled = true; }
          if (addText) { addText.textContent = 'Unavailable'; }
          return;
        }

        if (idInput) { idInput.value = variant.id; }

        if (priceEl && variant.priceFormatted) {
          priceEl.innerHTML = variant.priceFormatted;
        }

        if (compareEl) {
          if (variant.comparePresent && variant.comparePresent > 0 && variant.compareFormatted) {
            compareEl.innerHTML = variant.compareFormatted;
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }

        if (addBtn) { addBtn.disabled = !variant.available; }
        if (addText) { addText.textContent = variant.available ? 'Add to cart' : 'Sold out'; }

        if (mainImg && variant.featuredImage) { mainImg.src = variant.featuredImage; }
      }

      selects.forEach(function (s) { s.addEventListener('change', update); });
      update();
    });
  }

  function init() {
    initGalleries();
    initProductForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
